import React, {Component} from 'react';

export default class ErrorMessageContainer extends Component {
    constructor() {
        super();
    }

    render() {
        let errors = this.props.errors;
        let error_items = [];

        for (let key in errors) {
            if (errors.hasOwnProperty(key)) {
                for (let key2 in errors[key]) {
                    if (errors[key].hasOwnProperty(key2)) {
                        error_items.push(<li key={key + "." + key2}>{errors[key][key2]}</li>);
                    }
                }
            }
        }

        let className = "alert alert-danger";
        if (errors.length === 0)
            className += " hidden";

        return (
            <div className={className}>
                <ul>{error_items}</ul>
            </div>
        );
    }
}